/**
 * Created by mukund on 7/14/15.
 */

'use strict';

angular.module('mediacloudApp')
    .factory('AssetService', function ($resource, $rootScope) {

        return {
            GetAllAssets: $resource('api/assets'),
            GetAssets: $resource('api/assets/all'),
            UploadCaption: $resource('api/asset/caption', {}, {
              create: {
                  method: "POST",
                  transformRequest: angular.identity,
                  headers: { 'Content-Type': undefined }
              }
            }),
            GetAssetCaptions: $resource('api/asset/captions'),
            DownloadCaption: $resource('api/asset/caption/download'),
            DeleteCaption: $resource('api/asset/caption/delete'),
            UploadAudioTrack: $resource('api/asset/audiotrack', {}, {
              create: {
                  method: "POST",
                  transformRequest: angular.identity,
                  headers: { 'Content-Type': undefined }
              }
            }),
            GetAssetAudioTracks: $resource('api/asset/audiotracks'),
            DownloadAudioTrack: $resource('api/asset/audiotrack/download'),
            DeleteAudioTrack: $resource('api/asset/audiotrack/delete'),
            GetAsset: $resource('api/asset'),
            GetCarouselAssets: $resource('api/carousel/assets'),
            toggleAssetFavorite: function(asset, assetId, collectionId, callback){

                var cb = callback || angular.noop,
                    action = asset.isFavorite ? 'remove' : 'add',
                    resource = $resource('api/asset/favorite');

                return resource.save({action: action, cid: collectionId, aid: assetId}, function(response){
                    return cb(response);
                }, function(err){
                    return cb(err);
                }).$promise;

            },
            ShowLink: $resource('api/asset/media/link/enable'),
            HideLink: $resource('api/asset/media/link/disable'),
            ToggleLinkStatus: $resource('api/asset/media/link/status'),
            GetComments: $resource('api/asset/comments'),
            AddComment: $resource('api/asset/comment/add'),
            DeleteComment: $resource('api/asset/comment/delete',{},{
                erase: {
                    method: 'DELETE', params: {}, isArray: false
                }
            }),
            DeleteAsset: $resource('api/assets/delete', {}, {
                erase: {
                    method: 'POST', params: {}, isArray: false
                }
            }),
            CopyAsset: $resource('api/assets/copy'),
            RecordPlayback: $resource('api/asset/media/record'),
            UpdateMetadata: $resource('api/asset/metadata/update', {}, {
                update : {
                    method: 'POST', params: {}, isArray: false
                }
            }),
            SetActiveStatuses: $resource('api/asset/setActiveStatuses', {}, {
                send : {
                    method: 'POST', params: {}, isArray: false
                }
            }),
            AddMedia: $resource('api/lms/embed', {}, {
                embed : {
                    method: 'POST', params: {}, isArray: false
                }
            }),
            GetClipInfo: $resource('api/asset/clip'),
            GetQuizInfo: $resource('api/asset/quiz'),
            GetQuizAttempt: $resource('api/quiz/getQuizAttempt'),
            GetLatestCompletedQuizAttemptForUser: $resource('api/quiz/getLatestCompletedQuizAttemptForUser'),
            GetInProgressQuizAttempt: $resource('api/quiz/getInProgressQuizAttempt'),
            EndQuizAttempt: $resource('api/quiz/endQuizAttempt', {}, {
                  send : {
                      method: 'POST', params: {}, isArray: false
                  }
               }),
            SubmitToCaptionsync: $resource('api/asset/submit/captionsync'),
            GetAssetFilePath: $resource('api/asset/filepath'),
            GetQuizSummaryReport: $resource('api/quiz/getQuizSummaryReport'),
            GetQuizTakerBreakdownReport: $resource('api/quiz/getQuizTakerBreakdownReport'),
            GetQuizTakerSubmissionReport: $resource('api/quiz/getQuizTakerSubmissionReport'),
            GetQuizTakerResponseReport: $resource('api/quiz/getQuizTakerResponseReport'),
            GetQuestionDetailsReport: $resource('api/quiz/getQuestionDetailsReport'),
            GetQuizMetadata: $resource('api/quiz/getQuizMetadata'),
            IsQuizLocked: $resource('api/quiz/isQuizLocked'),
            SubmitQuestionResponse: $resource('api/quiz/upsertQuizQuestionResponse', {}, {
                send : {
                    method: 'POST', params: {}, isArray: false
                }
            }),
            GetQuizAvailability: $resource('api/quiz/getQuizAvailability', {}, {
               get : {
                   method: 'GET', params: {}, isArray: false
               }
            }),
            SetQuizAvailability: function(assetId, collectionId, callback){
                 var cb = callback || angular.noop,
                     resource = $resource('api/quiz/setQuizAvailability?cid=' + collectionId + '&aid=' + assetId);

                 return resource.save({}, function(response){
                     return cb(response);
                 }, function(err){
                     return cb(err);
                 }).$promise;

             },
            PublishQuiz: $resource('api/quiz/publishQuiz', {}, {
               send : {
                   method: 'POST', params: {}, isArray: false
               }
            }),
            SetActiveStatus: $resource('api/asset/setActiveStatus', {}, {
               send : {
                   method: 'POST', params: {}, isArray: false
               }
            }),
            NewQuizMM: $resource('api/asset/newQuiz', {}, {
               send : {
                   method: 'POST', params: {}, isArray: false
               }
            }),
            CreateQuiz: $resource('api/quiz/createQuiz', {}, {
               send : {
                   method: 'POST', params: {}, isArray: false
               }
            }),
            EditQuiz: $resource('api/quiz/editQuiz', {}, {
               send : {
                   method: 'GET', params: {}, isArray: false
               }
            }),
            RepublishQuiz: $resource('api/quiz/republishQuiz', {}, {
               send : {
                   method: 'GET', params: {}, isArray: false
               }
            }),
            UpdateQuiz: $resource('api/quiz/updateQuiz', {}, {
               send : {
                   method: 'POST', params: {}, isArray: false
               }
            }),
            UpdateQuizCollection: $resource('api/quiz/updateQuizCollection', {}, {
               send : {
                   method: 'POST', params: {}, isArray: false
               }
            }),
            DeleteQuiz: $resource('api/quiz/deleteQuiz', {}, {
               send : {
                   method: 'DELETE', params: {}, isArray: false
               }
            }),
            AddQuestionToQuiz: $resource('api/quiz/addQuestionToQuiz', {}, {
               send : {
                   method: 'POST', params: {}, isArray: false
               }
            }),
            UpdateQuizQuestion: $resource('api/quiz/updateQuizQuestion', {}, {
               send : {
                   method: 'POST', params: {}, isArray: false
               }
            }),
            AddAnswersToQuiz: $resource('api/quiz/addAnswersToQuiz', {}, {
               send : {
                   method: 'POST', params: {}, isArray: false
               }
            }),
            UpdateQuizAnswer: $resource('api/quiz/updateQuizAnswer', {}, {
               send : {
                   method: 'POST', params: {}, isArray: false
               }
            }),
            DeleteQuizQuestion: $resource('api/quiz/deleteQuizQuestion', {}, {
               send : {
                   method: 'DELETE', params: {}, isArray: false,     transformResponse: [
                                                                         function (data) {
                                                                             return data;
                                                                         }
                                                                     ]
               }
            }),
            DeleteQuizAnswer: $resource('api/quiz/deleteQuizAnswer', {}, {
               send : {
                   method: 'DELETE', params: {}, isArray: false,     transformResponse: [
                                                                         function (data) {
                                                                             return data;
                                                                         }
                                                                     ]
               }
            }),
            AddQuizSettings: $resource('api/quiz/addQuizSettings', {}, {
               send : {
                   method: 'POST', params: {}, isArray: false
               }
            }),
            UpdateQuizSettings: $resource('api/quiz/updateQuizSettings', {}, {
               send : {
                   method: 'POST', params: {}, isArray: false
               }
            }),
        }
    })
    .factory('AVMedia', function ($resource) {
        return $resource('api/asset/media/av');
    })
    .factory('BlobMedia', function ($resource) {
        return $resource('api/asset/media/other', {}, {
            getMedia: {
                method: 'GET',
                headers: {
                    accept: '*/*'
                },
                responseType: 'arraybuffer',
                cache: true,
                transformResponse: function(data, headers) {
                    var mediaFile = null;
                    var contentType = headers('content-type').split(";")[0].trim();
                    if(data) {
                        mediaFile = new Blob([data], {
                            type: contentType
                        });
                    }

                    return { mediaFile: mediaFile };
                }
            }
        });
    })
    .factory('DownloadableMedia', function ($resource) {
        return $resource('api/asset/media/download', {}, {
            getMedia: {
                method: 'GET',
                headers: {
                    accept: '*/*'
                },
                responseType: 'arraybuffer',
                cache: true,
                transformResponse: function(data, headers) {
                    headers = headers();

                    var url = null,
                        fileName = null,
                        contentType = headers['content-type'],
                        disposition = headers['content-disposition'];

                    if (disposition && disposition.indexOf('attachment') !== -1) {
                        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        var matches = filenameRegex.exec(disposition);
                        if (matches != null && matches[1]) {
                            fileName = matches[1].replace(/['"]/g, '');
                        }
                    }

                    if(data) {
                        try {
                            var mediaFile = new Blob([data], {type: contentType});
                            url = URL.createObjectURL(mediaFile);
                        } catch(ex){
                            console.log(ex);
                        }
                    }

                    return { url: url, name: fileName };
                }
            }
        });
    })
    .factory('ZipMedia', function ($resource) {
        return $resource('api/asset/media/other', {}, {
            getMedia: {
                method: 'GET',
                headers: {
                    accept: '*/*'
                },
                responseType: '',
                cache: true,
                transformResponse: function(data) {
                    var mediaUrl = null;
                    if(data) {
                        mediaUrl = data
                    }

                    return { mediaUrl: mediaUrl };
                }
            }
        });
    });
